"use client";

import React from "react";

//Type
import { CardPlansProps } from "@/types";

import Switch from "@/components/switch";
// ...existing code...

//Style
import * as S from "./styles";

//Icons
import { Pencil, Rocket, Trash } from "lucide-react";
import { buildAvatarSrc } from "@/utils/buildAvatarSrc";

//Components
import ButtonIcon from "../buttonIcon";
import { format } from "path";
import { formatCurrency } from "@/utils/formatCurrency";

interface CardEmployeeProps extends CardPlansProps {
  isActive: boolean;
  onToggleActive: (id: string) => void;
  id: string;
  currency: string;
}

const CardEmployee: React.FC<CardEmployeeProps> = ({
  className,
  titleCard,
  textDescription,
  price,
  category,
  handleUpdate,
  handleRemove,
  service,
  avatar_url,
  avatar_path,
  isActive,
  onToggleActive,
  id,
  currency,
}) => {
  const [imageError, setImageError] = React.useState(false);
  const avatar = buildAvatarSrc({ avatar_url, avatar_path });
  return (
    <S.CardService className={className}>
      <S.Header>
        <S.HeaderCard>
          <S.FirstBox>
            <S.BoxIcon $hasImage={!!avatar && !imageError}>
              {avatar && !imageError ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src={avatar}
                  alt={titleCard}
                  className="w-full h-full object-cover"
                  onError={() => setImageError(true)}
                />
              ) : (
                <Rocket />
              )}
            </S.BoxIcon>
            <S.TitleCard>{titleCard}</S.TitleCard>
          </S.FirstBox>
          <S.LastBox>
            <ButtonIcon
              icon={<Pencil />}
              hovercolor="green"
              onClick={handleUpdate}
            />
            <ButtonIcon
              icon={<Trash />}
              hovercolor="red"
              onClick={handleRemove}
            />
          </S.LastBox>
        </S.HeaderCard>
        <S.BodyCard>
          <S.TextDescription>{textDescription}</S.TextDescription>
          <S.ListItemPlans>
            <S.ItemPlans>{service}</S.ItemPlans>
          </S.ListItemPlans>
        </S.BodyCard>
        <S.StatusRow>
          <span
            style={{
              color: isActive ? "green" : "red",
              fontWeight: 600,
            }}
          >
            {isActive ? "Ativo" : "Inativo"}
          </span>
          <Switch checked={isActive} onChange={() => onToggleActive(id)} />
        </S.StatusRow>
      </S.Header>
      <S.FooterCard>
        <S.Value>{formatCurrency(Number(price) ?? 0, currency)}</S.Value>
        <S.Time>{category}</S.Time>
      </S.FooterCard>
    </S.CardService>
  );
};

export default CardEmployee;
